/**
 * Formats a seconds value as hh:mm:ss
 * */
export function formatSeconds(time: number = 0) {
  function pad(num: number, size: number) {
    return ('000' + num).slice(size * -1);
  }

  const hours = Math.floor(time / 60 / 60);
  const minutes = Math.floor(time / 60) % 60;
  const seconds = Math.floor(time - minutes * 60);

  return `${hours ? pad(hours, 2) + ':' : ''}${pad(minutes, 2)}:${pad(seconds, 2)}`;
}
